import { makeStyles, Tab, Tabs as TabsCore } from '@material-ui/core';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import React from 'react';

const useStyles = makeStyles({
  tab: {
    '& .MuiTab-root:not(.Mui-disabled):not(.Mui-selected)': {
      color: '#000',
    },
  },
});

const focoTour = (label) => {
  if (label === 'Parâmetros') {
    return <div className="stepParametros">{label}</div>;
  } else if (label === 'Contas') {
    return <div className="stepContas">{label}</div>;
  } else if (label === 'Usuários') {
    return <div className="stepUsuarios">{label}</div>;
  } else if (label === 'Grupos de acesso') {
    return <div className="stepGrupoAcesso">{label}</div>;
  } else if (label === 'Categorias') {
    return <div className="stepCategorias">{label}</div>;
  } else if (label === 'Centro de custos') {
    return <div className="stepCentroCusto">{label}</div>;
  } else if (label === 'Vendedores') {
    return <div className="stepVendedores">{label}</div>;
  }
};

const Abas = ({ value, onChange, tabs, onTour, isScrollable }) => {
  const classes = useStyles();
  return (
    <TabsCore
      value={value}
      onChange={(event, val) => onChange(val)}
      className={classes.tab}
      indicatorColor="primary"
      textColor="primary"
      variant={isScrollable ? 'scrollable' : 'fullWidth'}
      scrollButtons="auto"
      classes={{ root: 'w-full h-64' }}
    >
      {tabs &&
        tabs.map((tab, index) => {
          return (
            <Tab
              key={tab.key}
              className="h-64 normal-case"
              disabled={tab.disabled}
              icon={
                <div>
                  {onTour ? focoTour(tab.label) : tab.label}
                  {tab.hasError && tab.hasError() && <PriorityHighIcon style={{ paddingLeft: '4px', color: 'red' }} />}
                </div>
              }
            />
          );
        })}
    </TabsCore>
  );
};

export default Abas;
